/** 
 * @type {import("./defs").StoreProjectAccount} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreProjectAccount} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectAccount.js